// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, UpdatePrice } from "@insite/client-framework/Store/Pages/ProductList/Handlers/ChangeUnitOfMeasure";

export const xUpdatePrice: typeof UpdatePrice = props => {
    // xng-change: CES-816 prevent Price Update incase we change the uom
    // const state = props.getState();
    // const { productId, unitOfMeasure } = props.parameter;
    // const product = getProductState(state, productId).value;
    // if (!product || product.quoteRequired) {
    //     return;
    // }
    // const productInfo = state.pages.productList.productInfosByProductId[productId];
    // if (!productInfo) {
    //     return;
    // }
    // props.dispatch(
    //     loadRealTimePricing({
    //         productPriceParameters: [
    //             {
    //                 productId,
    //                 qtyOrdered: productInfo.qtyOrdered,
    //                 unitOfMeasure: unitOfMeasure ?? "",
    //             },
    //         ],
    //         onSuccess: realTimePricing => {
    //             const pricing = realTimePricing.realTimePricingResults!.find(o => o.productId === productId);
    //             if (pricing) {
    //                 props.dispatch({
    //                     type: "Pages/ProductList/CompleteLoadRealTimePricing",
    //                     realTimePricing,
    //                 });
    //             } else {
    //                 props.dispatch({
    //                     type: "Pages/ProductList/FailedLoadRealTimePricing",
    //                     productId,
    //                 });
    //             }
    //         },
    //         onError: () => {
    //             props.dispatch({
    //                 type: "Pages/ProductList/FailedLoadRealTimePricing",
    //                 productId,
    //             });
    //         },
    //         onComplete(realTimePricingProps) {
    //             if (realTimePricingProps.apiResult) {
    //                 this.onSuccess?.(realTimePricingProps.apiResult);
    //             } else if (realTimePricingProps.error) {
    //                 this.onError?.(realTimePricingProps.error);
    //             }
    //         },
    //     }),
    // );
};

replaceInChain(chain, UpdatePrice, xUpdatePrice);
